<template>
	<div>
		<case-form :schema="schema" class="mt6" />
		<div class="fs4 fw7 lh125 mt6 mb2">
			如选择"是"，请完成以下问题：
		</div>
		<j-accordion
			v-for="i in 4"
			:key="i"
			class="b1 bc7 mb2 r2"
			colorWhenClosed="bg5"
			colorWhenOpen="bg2"
		>
			<div slot="title" class="p2">
				<span class="mr1">有效保险</span>
				{{ i }}
			</div>
			<div slot="body" class="pr6 pl6 pt6 pb2 bg5">
				<case-form :schema="schemaList(i)" :isBoxed="false" />
			</div>
		</j-accordion>
		<case-form :schema="schemaExtra" class="mt6" />
		<case-form :schema="schemaPending" class="mt6" />
		<div class="fs4 fw7 lh125 mt6 mb2">
			如选择"是"，请完成以下问题：
		</div>
		<j-accordion
			v-for="i in 3"
			:key="i"
			class="b1 bc7 mb2 r2"
			colorWhenClosed="bg5"
			colorWhenOpen="bg2"
		>
			<div slot="title" class="p2">
				<span class="mr1">保险执行力</span>
				{{ i }}
			</div>
			<div slot="body" class="pr6 pl6 pt6 pb2 bg5">
				<case-form :schema="schemaPendingList(i)" :isBoxed="false" />
			</div>
		</j-accordion>
		<case-form :schema="schemaExtra2" class="mt6" />
		<case-form :schema="schemaDeclined" class="mt6" />
		<div class="fs4 fw7 lh125 mt6 mb2">
			如选择"是"，请完成以下问题：
		</div>
		<j-accordion
			v-for="i in 3"
			:key="i"
			class="b1 bc7 mb2 r2"
			colorWhenClosed="bg5"
			colorWhenOpen="bg2"
		>
			<div slot="title" class="p2">
				<span class="mr1">详情</span>
				{{ i }}
			</div>
			<div slot="body" class="pr6 pl6 pt6 pb2 bg5">
				<case-form :schema="schemaDeclinedList(i)" :isBoxed="false" />
			</div>
		</j-accordion>
	</div>
</template>

<script>
import CaseForm from "@/modules/caseManagement/components/CaseForm/CaseForm.vue"
import JAccordion from "@/components/JAccordion/"

export default {
	components: {
		CaseForm,
		JAccordion
	},

	computed: {
		schema() {
			return [
				{
					label: `您是否持有生效寿险？`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasLifeInsuranceCN`,
					props: {
						suggest: {
							typeIncludes: `hasLifeInsuranceCN`
						},
						createOptions: {
							type: `hasLifeInsuranceCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "有效保险总额(美元)",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0totalInsuranceInForceCN`,
					props: {
						suggest: {
							typeIncludes: `totalInsuranceInForceCN`
						},
						createOptions: {
							type: `totalInsuranceInForceCN`,
							dataType: "number"
						}
					}
				}
			]
		},
		schemaPending() {
			return [
				{
					label: `您是否有正在申请的人寿保险正在审理中或考虑中？`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasLifeInsurancePendingCN`,
					props: {
						suggest: {
							typeIncludes: `hasLifeInsurancePendingCN`
						},
						createOptions: {
							type: `hasLifeInsurancePendingCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "尚未确定的保险总额 (所有公司) (美元)",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0totalInsurancePendingCN`,
					props: {
						suggest: {
							typeIncludes: `totalInsurancePendingCN`
						},
						createOptions: {
							type: `totalInsurancePendingCN`,
							dataType: "number"
						}
					}
				},
				{
					label: "在待处理的金额中，您打算接受多少？ （美元）",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0insuranceAmountIntendToAcceptCN`,
					props: {
						suggest: {
							typeIncludes: `insuranceAmountIntendToAcceptCN`
						},
						createOptions: {
							type: `insuranceAmountIntendToAcceptCN`,
							dataType: "number"
						}
					}
				}
			]
		},
		schemaExtra() {
			return [
				{
					label: `您是否计划取代、改变现有保单，或使用任何现有保单的价值，作为您可能申请保单的保费？`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasPlanToReplaceOrChangeExistingLifeInsuranceCN`,
					props: {
						suggest: {
							typeIncludes: `hasPlanToReplaceOrChangeExistingLifeInsuranceCN`
						},
						createOptions: {
							type: `hasPlanToReplaceOrChangeExistingLifeInsuranceCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `如果“是”，请提供详细信息：`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0replaceOrChangeOfLifeInsuranceDetailsCN`,
					props: {
						suggest: {
							typeIncludes: `replaceOrChangeOfLifeInsuranceDetailsCN`
						},
						createOptions: {
							type: `replaceOrChangeOfLifeInsuranceDetailsCN`,
							dataType: "string"
						}
					}
				}
			]
		},
		schemaExtra2() {
			return [
				{
					label: `配置于所有保险公司的保单金额总和是多少（包括已经生效的人寿保险保额）？`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0ultimateTotalLineCN`,
					props: {
						suggest: {
							typeIncludes: `ultimateTotalLineCN`
						},
						createOptions: {
							type: `ultimateTotalLineCN`,
							dataType: "string"
						}
					}
				}
			]
		},
		schemaDeclined() {
			return [
				{
					label: `您是否曾申请过人寿保险、残障保险、重大疾病保险、健康保险或长期护理保险并有任何被拒绝、被加保、被延期、被取消或被更改
的经历？`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasInsuranceApplicationDeclinedCN`,
					props: {
						suggest: {
							typeIncludes: `hasInsuranceApplicationDeclinedCN`
						},
						createOptions: {
							type: `hasInsuranceApplicationDeclinedCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `详情`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasInsuranceApplicationDeclinedDetailsCN`,
					props: {
						suggest: {
							typeIncludes: `hasInsuranceApplicationDeclinedDetailsCN`
						},
						createOptions: {
							type: `hasInsuranceApplicationDeclinedDetailsCN`,
							dataType: "string"
						}
					}
				}
			]
		}
	},

	methods: {
		schemaList(i) {
			return [
				{
					label: `保险公司名称`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0currentLifeInsuranceCompany${i}CN`,
					props: {
						suggest: {
							typeIncludes: `currentLifeInsuranceCompany${i}CN`
						},
						createOptions: {
							type: `currentLifeInsuranceCompany${i}CN`,
							dataType: "string"
						}
					}
				},
				{
					label: `城市`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0currentLifeInsuranceCity${i}CN`,
					props: {
						suggest: {
							typeIncludes: `currentLifeInsuranceCity${i}CN`
						},
						createOptions: {
							type: `currentLifeInsuranceCity${i}CN`,
							dataType: "string"
						}
					}
				},
				{
					label: `州/省`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0currentLifeInsuranceStateOrProvince${i}CN`,
					props: {
						suggest: {
							typeIncludes: `currentLifeInsuranceStateOrProvince${i}CN`
						},
						createOptions: {
							type: `currentLifeInsuranceStateOrProvince${i}CN`,
							dataType: "string"
						}
					}
				},
				{
					label: `国家`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0currentLifeInsuranceCountry${i}CN`,
					props: {
						suggest: {
							typeIncludes: `currentLifeInsuranceCountry${i}CN`
						},
						createOptions: {
							type: `currentLifeInsuranceCountry${i}CN`,
							dataType: "string"
						}
					}
				},
				{
					label: `生效保险金额`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0currentLifeInsuranceCoverageAmount${i}CN`,
					props: {
						suggest: {
							typeIncludes: `currentLifeInsuranceCoverageAmount${i}CN`
						},
						createOptions: {
							type: `currentLifeInsuranceCoverageAmount${i}CN`,
							dataType: "string"
						}
					}
				},
				{
					label: `签发年份`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0currentLifeInsuranceYearOfIssue${i}CN`,
					props: {
						suggest: {
							typeIncludes: `currentLifeInsuranceYearOfIssue${i}CN`
						},
						createOptions: {
							type: `currentLifeInsuranceYearOfIssue${i}CN`,
							dataType: "string"
						}
					}
				},
				{
					label: `保险类别`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0currentLifeInsuranceType${i}CN`,
					props: {
						suggest: {
							typeIncludes: `currentLifeInsuranceType${i}CN`
						},
						createOptions: {
							type: `currentLifeInsuranceType${i}CN`,
							dataType: "string"
						}
					}
				}
			]
		},
		schemaPendingList(i) {
			return [
				{
					label: `保险公司的名称`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0pendingLifeInsuranceCompany${i}CN`,
					props: {
						suggest: {
							typeIncludes: `pendingLifeInsuranceCompany${i}CN`
						},
						createOptions: {
							type: `pendingLifeInsuranceCompany${i}CN`,
							dataType: "string"
						}
					}
				},
				{
					label: `城市`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0pendingLifeInsuranceCity${i}CN`,
					props: {
						suggest: {
							typeIncludes: `pendingLifeInsuranceCity${i}CN`
						},
						createOptions: {
							type: `pendingLifeInsuranceCity${i}CN`,
							dataType: "string"
						}
					}
				},

				{
					label: `州/省`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0pendingLifeInsuranceStateOrProvince${i}CN`,
					props: {
						suggest: {
							typeIncludes: `pendingLifeInsuranceStateOrProvince${i}CN`
						},
						createOptions: {
							type: `pendingLifeInsuranceStateOrProvince${i}CN`,
							dataType: "string"
						}
					}
				},
				{
					label: `国家`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0pendingLifeInsuranceCountry${i}CN`,
					props: {
						suggest: {
							typeIncludes: `pendingLifeInsuranceCountry${i}CN`
						},
						createOptions: {
							type: `pendingLifeInsuranceCountry${i}CN`,
							dataType: "string"
						}
					}
				},
				{
					label: `生效保单金额`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0pendingLifeInsuranceCoverageAmount${i}CN`,
					props: {
						suggest: {
							typeIncludes: `pendingLifeInsuranceCoverageAmount${i}CN`
						},
						createOptions: {
							type: `pendingLifeInsuranceCoverageAmount${i}CN`,
							dataType: "string"
						}
					}
				},
				{
					label: `申请日期`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0pendingLifeInsuranceApplicationDate${i}CN`,
					props: {
						suggest: {
							typeIncludes: `pendingLifeInsuranceApplicationDate${i}CN`
						},
						createOptions: {
							type: `pendingLifeInsuranceApplicationDate${i}CN`,
							dataType: "date"
						}
					}
				}
			]
		},
		schemaDeclinedList(i) {
			return [
				{
					label: `申请年份`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0declinedApplicationYear${i}CN`,
					props: {
						suggest: {
							typeIncludes: `declinedApplicationYear${i}CN`
						},
						createOptions: {
							type: `declinedApplicationYear${i}CN`,
							dataType: "string"
						}
					}
				},
				{
					label: `保险公司名称`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0declinedApplicationInsuranceCompany${i}CN`,
					props: {
						suggest: {
							typeIncludes: `declinedApplicationInsuranceCompany${i}CN`
						},
						createOptions: {
							type: `declinedApplicationInsuranceCompany${i}CN`,
							dataType: "string"
						}
					}
				},
				{
					label: `申请产品类型`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0declinedApplicationProduct${i}CN`,
					props: {
						suggest: {
							typeIncludes: `declinedApplicationProduct${i}CN`
						},
						createOptions: {
							type: `declinedApplicationProduct${i}CN`,
							dataType: "string"
						}
					}
				},
				{
					label: `保险公司决定及理由`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0declinedApplicationReason${i}CN`,
					props: {
						suggest: {
							typeIncludes: `declinedApplicationReason${i}CN`
						},
						createOptions: {
							type: `declinedApplicationReason${i}CN`,
							dataType: "string"
						}
					}
				}
			]
		}
	}
}
</script>
